import { ref as h, computed as i, createElementBlock as a, openBlock as n, normalizeStyle as f, normalizeClass as p, createElementVNode as d, createCommentVNode as g, toDisplayString as u } from "vue";
import { screenProp as v } from "../../utils/utilsScreen.js";
/* empty css                   */
import y from "../../_virtual/_plugin-vue_export-helper.js";
import E from "../../utils/validators/image.js";
const S = ["poster"], x = ["src", "type"], b = {
  key: 0,
  "aria-hidden": "true",
  class: "ds-video__error-message ds-heading-xsmall"
}, w = /* @__PURE__ */ Object.assign({
  name: "DsVideoElement"
}, {
  __name: "video-element",
  props: {
    ...v,
    thumbnail: {
      type: Object,
      required: !0,
      validator: (e) => E(e)
    },
    sizes: {
      type: Object,
      default: null
    },
    selfHosted: {
      type: Boolean,
      default: !1
    },
    src: {
      type: String,
      required: !0
    },
    title: {
      type: String,
      required: !0
    },
    extension: {
      type: String,
      default: ""
    },
    fullHeight: {
      type: Boolean,
      default: !1
    },
    showError: {
      type: Boolean,
      default: !0
    },
    errorMessage: {
      type: String,
      default: "Failed to load video - "
    }
  },
  setup(e) {
    const l = h(!1), o = e, c = () => {
      l.value = !0;
    }, m = i(() => {
      var t, r;
      return ((r = (t = o.thumbnail) == null ? void 0 : t[o.screen]) == null ? void 0 : r.src) ?? null;
    }), s = i(() => {
      var t;
      return ((t = o.sizes) == null ? void 0 : t[o.screen]) ?? { width: "auto", height: "auto" };
    });
    return (t, r) => (n(), a("div", {
      class: p(["ds-video", { "ds-video--full-height": e.fullHeight }]),
      style: f(e.fullHeight ? null : { minWidth: `${s.value.width}px`, minHeight: `${s.value.height}px` }),
      "data-j-video": ""
    }, [
      d("video", {
        autoplay: "",
        loop: "",
        muted: "",
        playsinline: "",
        poster: m.value
      }, [
        d("source", {
          src: e.src,
          type: `video/${e.extension}`,
          onError: c
        }, null, 40, x)
      ], 8, S),
      l.value && e.showError ? (n(), a("p", b, u(e.errorMessage) + " " + u(e.title), 1)) : g("", !0)
    ], 6));
  }
}), _ = /* @__PURE__ */ y(w, [["__scopeId", "data-v-55d949ff"]]);
export {
  _ as default
};
